import * as constActions from './Consts';

import initialState from './initialState';

export default function searchPageReducer(state = initialState, action) {
  switch (action.type) {
    case constActions.RADAR_TOP_10_ALERTS: {
      return Object.assign({}, state, {
        top10FileAlerts: action.results.alerts.FileAlerts,
        top10HostAlerts: action.results.alerts.HostAlerts,
        top10NetworkAlerts: action.results.alerts.NetworkAlerts,
        top10UserAlerts: action.results.alerts.UserAlerts,

        fileAlertsCount: action.results.alerts.FileAlertsCount,
        userAlertsCount: action.results.alerts.UserAlertsCount,
        hostAlertsCount: action.results.alerts.HostAlertsCount,
        networkAlertsCount: action.results.alerts.NetworkAlertsCount,

        alerts: [
          ...action.results.alertsDetails.Files,
          ...action.results.alertsDetails.Hosts,
          ...action.results.alertsDetails.Users,
          ...action.results.alertsDetails.Networks
        ]
      });
    }
    case constActions.REPORT_ALERTS: {
      return Object.assign({}, state, {
        alerts: action.results.alerts
      });
    }
    case constActions.GET_ADVANCED_REPORTS_LIST: {
      return Object.assign({}, state, {
        reports: action.results.reports || []
      });
    }
    case constActions.GET_ADVANCED_REPORTS_CONFIGURATION: {
      return Object.assign({}, state, {
        ssoToken: action.results.ssoToken,
        baseUrl: action.results.baseUrl
      });
    }
    case constActions.REPORT_ALERTS_LOAD_MORE: {
      return Object.assign({}, state, {
        alerts: [...state.alerts, ...action.results.alerts]
      });
    }
    case constActions.UPDATE_DATE_FROM: {
      return Object.assign({}, state, {
        startDate: action.startDate
      });
    }
    case constActions.UPDATE_DATE_TO: {
      return Object.assign({}, state, {
        endDate: action.endDate
      });
    }
    case constActions.ALERTS_BY_STATUS_IN_DATE_RANGE: {
      return Object.assign({}, state, {
        lowAlerts: action.results.LowAlerts.Alerts,
        medAlerts: action.results.MedAlerts.Alerts,
        highAlerts: action.results.HighAlerts.Alerts,
        allAlerts: action.results.AllAlerts.Alerts,

        countTotalAlerts: action.results.AllAlerts.TotalOpen + action.results.AllAlerts.TotalClosed,
        countHighAlerts: action.results.HighAlerts.TotalOpen + action.results.HighAlerts.TotalClosed,
        countMedAlerts: action.results.MedAlerts.TotalOpen + action.results.MedAlerts.TotalClosed,
        countLowAlerts: action.results.LowAlerts.TotalOpen + action.results.LowAlerts.TotalClosed,
        countOpendAlerts: action.results.AllAlerts.TotalOpen,
        countClosedAlerts: action.results.AllAlerts.TotalClosed
      });
    }
    case constActions.ALERTS_COUNT_BY_ENTITY: {
      return Object.assign({}, state, {
        AlertsCountByDate: action.results
      });
    }
    case constActions.START_SPINNER: {
      return Object.assign({}, state, {
        isSpinner: action.result
      });
    }
    case constActions.STOP_SPINNER: {
      return Object.assign({}, state, {
        isSpinner: action.result
      });
    }
    case constActions.FETCH_DATA_FLAG: {
      return Object.assign({}, state, {
        IsFetchData: action.result
      });
    }
    case constActions.SET_PRESERNT_DATA_STATUS: {
      return Object.assign({}, state, {
        preserntDataStatus: action.status
      });
    }
    case constActions.UPDATE_ALERT_ROWS: {
      return Object.assign({}, state, {
        alerts: action.alerts
      });
    }

    default:
      return state;
  }
}
